export default __webpack_public_path__ + "static/media/PSQI.12a2267a.pdf";